import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import './index.css';

import Navbar      from './components/ui/Navbar';
import Hero        from './components/sections/Hero';
import Activities  from './components/sections/Activities';
import BuggySection from './components/sections/BuggySection';
import FoodSection from './components/sections/FoodSection';
import Gallery     from './components/sections/Gallery';
import Reservation from './components/sections/Reservation';
import Access      from './components/sections/Access';
import FAQ         from './components/sections/FAQ';
import Footer      from './components/ui/Footer';
import NoticeBoard from './components/sections/NoticeBoard';

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <Hero />
        <Activities />
        <BuggySection />
        <FoodSection />
        <Gallery />
        <Reservation />
        <Access />
        <FAQ />
        <NoticeBoard />  
      </main>
      <Footer />
    </BrowserRouter>
  );
}
